import { observable, action } from 'mobx';
import { TNotification } from '../../../../apis/notification/getNotificationList';

class NotificationStore {
	loadPageSize = 20;
	@observable notificationList: TNotification[];
	@observable noMoreData = false;

	@action
	setNotificationList = (list?: TNotification[]) => {
		this.notificationList = list;
		this.noMoreData = list?.length < this.loadPageSize;
	}

	@action
	appendNotificationList = (list: TNotification[]) => {
		this.notificationList = this.notificationList.concat(list);
		this.noMoreData = list.length < this.loadPageSize;
	}

	@action
	markNotificationHasRead = (notificationId: string) => {
		if (this.notificationList) {
			const targetItem = this.notificationList.find((item: TNotification) => {
				return notificationId === item.uid;
			});
			if (targetItem) {
				targetItem.hasRead = true;
			}
		}
	};

	@action
	deleteNotification = (target: TNotification) => {
		const deleteIndex = this.notificationList.findIndex((item: TNotification, _) => target.id === item.id);
		deleteIndex >= 0 && this.notificationList.splice(deleteIndex, 1);
	}
}

export default new NotificationStore();
